export default "__VITE_ASSET__DI0Iasxw__"